import { IInitialState } from "us.collection.transactions/reducers/ApplicableCourts/Interfaces";

export const initialState: IInitialState = {
  courts: {
    data: [],
    isFetching: false,
  },
};
